import { maxBy } from "lodash";

import { syncStatusOptions, syncStatusSeverity } from "../../constants/syncStatus";
import syncUpdateActions from "../../constants/syncUpdateActions";

export const syncStatusForAction = action => {
  switch (action) {
    case syncUpdateActions.NONE:
      return syncStatusOptions.DETECTED_NO_CHANGE;
    case syncUpdateActions.IGNORE:
      return syncStatusOptions.DETECTED_IGNORE;
    case syncUpdateActions.APPLY_MOVE_TO_LOCAL:
      return syncStatusOptions.DETECTED_MOVE_IN_EXTERNAL;
    case syncUpdateActions.APPLY_MOVE_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_MOVE_IN_LOCAL;
    case syncUpdateActions.APPLY_CREATE_TO_LOCAL:
      return syncStatusOptions.DETECTED_CREATE_IN_EXTERNAL;
    case syncUpdateActions.APPLY_CREATE_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_CREATE_IN_LOCAL;
    case syncUpdateActions.APPLY_DELETE_TO_LOCAL:
      return syncStatusOptions.DETECTED_DELETE_IN_EXTERNAL;
    case syncUpdateActions.APPLY_DELETE_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_DELETE_IN_LOCAL;
    case syncUpdateActions.APPLY_LOCAL_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_LOCAL;
    case syncUpdateActions.APPLY_EXTERNAL_TO_LOCAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_EXTERNAL;
    case syncUpdateActions.UNRESOLVED:
      return syncStatusOptions.DETECTED_CONFLICT;
    default:
      return syncStatusOptions.DETECTED_NO_CHANGE;
  }
};

export const syncStatusForKeywordAction = action => {
  switch (action) {
    case syncUpdateActions.APPLY_CREATE_TO_LOCAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_EXTERNAL;
    case syncUpdateActions.APPLY_CREATE_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_LOCAL;
    case syncUpdateActions.APPLY_DELETE_TO_LOCAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_EXTERNAL;
    case syncUpdateActions.APPLY_DELETE_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_LOCAL;
    case syncUpdateActions.APPLY_LOCAL_TO_EXTERNAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_LOCAL;
    case syncUpdateActions.APPLY_EXTERNAL_TO_LOCAL:
      return syncStatusOptions.DETECTED_CHANGE_IN_EXTERNAL;
    case syncUpdateActions.UNRESOLVED:
      return syncStatusOptions.DETECTED_CONFLICT;
    case syncUpdateActions.IGNORE:
      return syncStatusOptions.DETECTED_IGNORE;
    default:
      return syncStatusOptions.DETECTED_NO_CHANGE;
  }
};

/**
 *
 * @param {List} actions
 */
export const syncStatusForActionArray = actions => {
  const statuses = actions.map(a => syncStatusForAction(a));
  return maxBy(statuses, s => syncStatusSeverity[s]);
};

/**
 *
 * @param {Map} propertyUpdates
 */
export const syncStatusForPropertyUpdates = propertyUpdates => {
  const statuses = propertyUpdates.map(p => syncStatusForAction(p.action));
  const result = statuses.maxBy(s => syncStatusSeverity[s]);
  return result;
};

/**
 *
 * @param {SyncUpdateRecord} updateRecord
 */
export const syncStatusForUpdateRecord = docUpdate => {
  let statuses = docUpdate.propertyUpdates
    .map(p => syncStatusForAction(p.action))
    .toList()
    .push(syncStatusForAction(docUpdate.action))
    .concat(docUpdate.tagUpdates.map(u => syncStatusForKeywordAction(u.action)).toList())
    .concat(docUpdate.relationshipUpdates.map(u => syncStatusForKeywordAction(u.action)).toList());

  // console.log(`syncStatusForUpdateRecord(): printing docUpdate, statuses`);
  // console.dir(docUpdate.toJS());
  // console.dir(statuses.toJS());
  // console.log(`... will return ${statuses.maxBy(s => syncStatusSeverity[s])}`);

  return statuses.maxBy(s => syncStatusSeverity[s]);
};

// Returns true if this action will result to a change in document content or metadata
// Document position is not considered
const actionIsExternalContentChange = action => {
  switch (action) {
    case syncUpdateActions.APPLY_CREATE_TO_EXTERNAL:
    case syncUpdateActions.APPLY_LOCAL_TO_EXTERNAL:
    case syncUpdateActions.APPLY_DELETE_TO_EXTERNAL:
      return true;
    default:
      return false;
  }
};

// Returns true if this action will result to a change in document content or metadata
// Document position is not considered
export const keywordActionIsExternalContentChange = action => {
  switch (action) {
    case syncUpdateActions.APPLY_CREATE_TO_EXTERNAL:
    case syncUpdateActions.APPLY_DELETE_TO_EXTERNAL:
    case syncUpdateActions.APPLY_LOCAL_TO_EXTERNAL:
      return true;
    default:
      return false;
  }
};

/**
 *
 * @param {SyncUpdateRecord} updateRecord
 */
export const syncExternalDocumentContentWillChangeForUpdateRecord = docUpdate => {
  const result =
    Boolean(docUpdate.propertyUpdates.find(p => actionIsExternalContentChange(p.action))) ||
    Boolean(docUpdate.tagUpdates.find(u => keywordActionIsExternalContentChange(u.action))) ||
    Boolean(docUpdate.relationshipUpdates.find(u => keywordActionIsExternalContentChange(u.action)));

  return result;
};
